import { SeuBadgeColor } from '@seu-types';

export function getBadgeColorFromKey(key: unknown): SeuBadgeColor {
  switch (key) {
    case 'metal':
      return 'metal';
    case 'glass':
      return 'glass';
    case 'ligno':
      return 'ligno';
    case 'ercs':
      return 'ercs';
    case 'energy':
      return 'energy';
    case 'panels':
      return 'panels';
    case 'imi':
      return 'imi';
    case 'WARRANTY':
      return 'beige';
    case 'MAXIMUM_LOAD':
      return 'aubergine';
    case 'PART_LOAD':
      return 'petrol';
    case 'OTHER':
      return 'brown';
    case 'NOMINAL':
      return 'olive';
    default:
      return 'other';
  }
}
